import { Button, Modal } from "react-bootstrap";
import { useAppDispatch } from "../../app/hooks";
import { FC, useState } from "react";
import AdminSubmenu from "../../features/adminSubmenu";
import { syncOrderStatuses } from "../../app/services/orderService";
import { useAccount, useMsal } from "@azure/msal-react";
import { RootState } from "../../app/store";
import { useSelector } from "react-redux";


interface Props { }

const AdminSyncStatus: FC<Props> = () => {
    const dispatch = useAppDispatch();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [displayError, setDisplayError] = useState(false);

    const isWaitingOrderStatusSyncResponse = useSelector(
        (state: RootState) => state.order.isWaitingOrderStatusSyncResponse,
    );
    const synchronizeOrdersHandler = () => {
        dispatch(syncOrderStatuses(instance, account, onSuccess));
    };
    const onSuccess = (success: boolean | null) => {
        if (!success) {
            setDisplayError(true);
        }
    };

    return (
        <div>
            <AdminSubmenu />

            <div>
                <h2 className="mb-3">Synka orderstatus</h2>
                <p>
                    När du synkar orderstatus hämtar AD One alla orders med status <em>Inköp</em> och kontrollerar deras status i AX via FO.
                    <br />
                    Om en order är utlevererad i AX uppdateras statusen automatiskt till <em>Leverans</em> i AD One.
                    <br />
                    Detta kan ta en stund beroende på hur många ordrar som behöver synkas.
                    <br />
                    Det finns även en automtisk synk som körs varje natt för att hålla statusarna uppdaterade, så det är inte nödvändigt att göra detta manuellt
                </p>
            </div>

            <Button
                variant="outline-primary"
                onClick={synchronizeOrdersHandler}
                disabled={isWaitingOrderStatusSyncResponse}
            >
                Synka orderstatus
            </Button>

            <Modal
                show={displayError}
                onHide={() => {
                    setDisplayError(false);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Fel vid synkronisering</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Något gick fel vid synkroniseringen av orderstatus.
                </Modal.Body>
                <Modal.Footer>

                    <Button
                        variant="primary"
                        onClick={() => {
                            setDisplayError(false);
                        }}
                    >
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AdminSyncStatus;
